// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagSurfaceModel extends SmartTagModel {
	surfaceType?: string;
	maintainedType?: string;

	constructor() {
		super();

		this.surfaceType = '';
		this.maintainedType = '';
	}
}

export class SmartTagSurface extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagSurfaceModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagSurfaceModel): void{
		const title = data.title || data.subCategory || '';
		const surfaceType = data.surfaceType || '';
		const maintainedType = data.maintainedType || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (surfaceType !== '') {
			this.addText(`<span title="${surfaceType}">Surface Type: ${surfaceType}</span>`);
		}

		if (maintainedType !== '') {
			this.addText(`<span title="Road is used to access: ${maintainedType}">Road is used to access: ${maintainedType}</span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
